import { useCallback } from "react";
import { useOverdueFilterStore } from "@/store/overdue-filter";

export function useOverdueFilter() {
  const { excludedTypes, hydrated, toggleType, includeAll, excludeAll } =
    useOverdueFilterStore();

  const isTypeIncluded = useCallback(
    (typeName: string) => {
      if (!hydrated) return true;
      return !excludedTypes.includes(typeName);
    },
    [excludedTypes, hydrated],
  );

  const hasActiveFilters = hydrated && excludedTypes.length > 0;
  const allIncluded = hydrated && excludedTypes.length === 0;

  return {
    excludedTypes,
    hydrated,
    toggleType,
    includeAll,
    excludeAll,
    isTypeIncluded,
    hasActiveFilters,
    allIncluded,
  };
}
